module.exports = __webpack_public_path__ + "static/media/mv.6ef58642.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mv.svg
// module id = 723
// module chunks = 0